import { useRef, useState } from "react";

import { devices, sizes } from "library/constants";
import styled from "styled-components";

import { useIsMobile } from "hooks/useIsMobile";

export function AppContent({ children }) {
  const contentRef = useRef<any>(null);
  const scrollbarRef = useRef<any>(null);
  const isMobile = useIsMobile();
  const [scrollWidth, setScrollWidth] = useState(0);

  const handleScroll = () => {
    if (!contentRef.current) return;

    const content = contentRef.current as any;
    const scrollTop = content.scrollTop;
    const height = content.scrollHeight - content.clientHeight;
    const scrolled = (scrollTop / height) * 100;

    setScrollWidth(scrolled);
  };

  return (
    <Container ref={contentRef} onScroll={handleScroll}>
      <>
        {children}

        <div
          className="header"
          ref={scrollbarRef}
          style={{
            display: isMobile ? "none" : "block",
            position: "fixed",
            zIndex: 999999,
            background: " #f1f1f1",
            height: "100%",
            width: "1px",
            top: sizes.appHeader + "px",
            right: "7px",
          }}
        >
          <div className="progress-container">
            <div
              className="progress-bar"
              id="myBar"
              style={{
                width: "6px",
                height: scrollWidth + "%",
              }}
            ></div>
          </div>
        </div>
      </>
    </Container>
  );
}

export default AppContent;

const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 0;

  flex-direction: column;
  position: relative;
  column-gap: 5px;
  // border: 1px solid ${({ theme }) => theme.palette.neutralLight};
  border-radius: 8px;
  // background-color: ${({ theme }) => theme.palette.white};
  box-sizing: border-box;
  width: 100%;
  overflow-y: auto;
  /* Hide scrollbar */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }

  @media only screen and ${devices.md} {
    margin: 10px 0 10px 10px;
  }

  .header h2 {
    text-align: center;
  }

  .progress-container {
    height: 100%;
    width: 6px;
    background: #ccc;
  }

  .progress-bar {
    background: ${({ theme }) => theme.palette.purpleDark};
    border-radius: 6px;
  }
`;
